import { Injectable } from '@angular/core';
import { FileDto } from '../common/FileDto';
import { readAsDataUrl } from '../common/browser-files';

/**
 * Holds in-memory image helpers used by several components for previews.
 * The HTTP-touching methods that used to live here (getByReference, download,
 * create, delete) were retired together with the backend's FileController
 * (#26 follow-up); customer documents now go through the entity-scoped
 * /api/customer/{id}/files and /api/sku/{id}/files endpoints.
 */
@Injectable({
  providedIn: 'root',
})
export class FileService {

  public createImageFromFile(file: File, fileDto: FileDto) {
    if (fileDto) {
      readAsDataUrl(file, (url) => (fileDto.image = url));
    }
  }

  public createImageFromBase64(fileDto: FileDto) {
    fileDto.image = 'data:image/jpg;base64,' + fileDto.base64Data;
  }
}
